import React from "react";
import { Wifi, WifiOff } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface ConnectionStatusProps {
  isConnected: boolean;
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  isConnected,
}) => {
  return (
    <Badge variant={isConnected ? "default" : "destructive"} className='gap-1'>
      {isConnected ? (
        <Wifi className='h-3 w-3' />
      ) : (
        <WifiOff className='h-3 w-3' />
      )}
      {isConnected ? "Connected" : "Disconnected"}
    </Badge>
  );
};
